/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Dang Quang Tuan (DQTuan)
 *
 * @description
 *
 * @created at 15/01/2025
 **/

import styled from "@emotion/styled";
import { Row } from "@/frameworks/designStuff/components";
import { Typography } from "@/frameworks/designStuff";

/**
 * Wrapper for ChannelCreateSystemChat component
 */
export const ChannelCreateSystemChatWrapper = styled(Row)`
	display: flex;
	width: 270px;
	padding: 8px 16px;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.68);
	backdrop-filter: blur(10px);
	min-height: 60px;
	justify-content: center;
`;

/**
 * Channel create system message styled components
 */
export const ChannelCreateSystemMessage = styled(Typography)`
	color: #2E2F32 !important;
	font-feature-settings: 'liga' off, 'clig' off !important;
	font-size: 15px !important;
	font-style: normal !important;
	font-weight: 600 !important;
	line-height: 22px !important;

	.invitees {
		color: #7F86F3 !important;
		cursor: pointer;
	}
`;
